import { Component, OnDestroy } from '@angular/core';
import { ChosenPPCharts } from '../../fund-performances/pojo/fp-export-classes';
import { CheckBoxSelector } from '../../../../shared/component/checkbox-selector/checkbox-selector.component';
import { cloneDeep } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { OrganizationsService } from '../../../../organization/components/service/organizations.service';
import { Subject } from 'rxjs';
import { AuthService } from '../../../../auth/service/auth.service';
import { HorNavbarService } from '../../../../../core/service/hor-navbar.service';
import { FundPerformance } from '../../../dto/FundPerformance';

@Component({
  selector: 'app-value-creation-charts',
  templateUrl: './value-creation-charts.component.html',
  styleUrls: ['./value-creation-charts.component.scss'],
})
export class ValueCreationChartsComponent implements OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  isAdmin = false;
  fundPerformances: FundPerformance[];
  fp: FundPerformance;
  selectedPeriod: Date;
  updateSelectedPeriodsForCharts = false;
  fpsHaveChartData = false;
  chartPeriods: CheckBoxSelector[] = [];
  chosenPPCharts: ChosenPPCharts[] = [
    { name: 'total', chosen: true, showModal: false },
    { name: 'active', chosen: false, showModal: false },
    { name: 'realized', chosen: false, showModal: false },
  ];

  constructor(
    private organizationsService: OrganizationsService,
    private authService: AuthService,
    private horNavbarService: HorNavbarService,
  ) {
    this.initSubscriptions();
    this.fpsHaveChartData = Boolean(this.fundPerformances.find((fp) => fp.totalCommitment && fp.contribution));
    this.initChartPeriods();
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  rerender(selectedPeriods: CheckBoxSelector[]): void {
    this.chartPeriods = cloneDeep(selectedPeriods);
    this.updateSelectedPeriodsForCharts = !this.updateSelectedPeriodsForCharts;
  }

  private initChartPeriods(): void {
    if (!this.selectedPeriod) {
      return;
    }
    const periodsFromFundPerformances = this.fundPerformances.filter((fp) => fp.isVisible)
      .sort((a, b) => new Date(b.period).getTime() - new Date(a.period).getTime())
      .map((fundPerformance) => fundPerformance.period.toString());
    const selectedPeriodIndex = periodsFromFundPerformances.indexOf(this.selectedPeriod.toString());
    this.chartPeriods = [];
    periodsFromFundPerformances.forEach((p, index) => {
      // To show -> selectedPeriod in hor nav and max 19 previous periods. All other periods shouldn't be shown
      if (index >= selectedPeriodIndex && index < (selectedPeriodIndex + 20)) {
        this.chartPeriods.push({ item: p, chosen: true });
      } else {
        this.chartPeriods.push({ item: p, chosen: false });
      }
    });
    this.updateSelectedPeriodsForCharts = !this.updateSelectedPeriodsForCharts;
  }

  private initSubscriptions(): void {
    this.authService.currentUserTypeForServices$.pipe(takeUntil(this._destroyStream)).subscribe((userType) => {
      this.isAdmin = userType === 'admin';
    });
    this.horNavbarService.getSelectedFundPerformance.pipe(takeUntil(this._destroyStream)).subscribe((fp) => {
      this.fp = fp;
    });
    this.horNavbarService.getFundPerformances.pipe(takeUntil(this._destroyStream)).subscribe((fps) => {
      this.fundPerformances = cloneDeep(fps);
    });
    this.horNavbarService.getSelectedPeriod.pipe(takeUntil(this._destroyStream)).subscribe((period) => {
      this.selectedPeriod = period;
    });
  }
}
